import { Injectable } from '@angular/core';
import {Storage} from '@ionic/storage';
import {User} from '../models/User';
import {Orden} from '../models/Orden';
import {Documentacion} from "../models/Documentacion";

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  usuario: User;
  lastsinc: Date = new Date();
  asignacion: any;
  ots: Array<Orden> = [];
  sync: Array<any> = [];
  etapas: Array<any> = [];
  documentacion: Array<any> = [];
  hseq: Array<any> = [];
  confApp: {
    etapa: {
      'etapaTerminado': any;
      'etapaIniciado': any;
      'etapaSuspendido': any;
      'etapaCaptura': any;
    };
    imagen: {
      auditoria: any;
      evidencia: any;
    };
  };

  constructor() {
  }

  setUsuario(usuario: User){
    this.usuario = usuario;
  }

  getUsuario(){
    return this.usuario;
  }

  setLastsinc(lastsinc){
    this.lastsinc = lastsinc;
  }

  getLastsinc(){
    return this.lastsinc;
  }

  setOTs(ot){
    this.ots = ot;
  }

  getOTs(){
    return this.ots;
  }

  setDataSync(ots) {
    this.sync = ots;
  }

  getDataSync(){
    return this.sync;
  }

  setEtapas(etapas) {
    this.etapas = etapas;
  }

  getEtapas(){
    return this.etapas;
  }

  setConfApp(conf) {
    this.confApp = conf;
  }

  getConfApp(){
    return this.confApp;
  }

  setDocumentacion(documentacion){
    this.documentacion = documentacion;
  }

  getDocumentacion(){
    return this.documentacion;
  }

  setHSEQ(hseq){
    this.hseq = hseq;
  }

  getHSEQ(){
    return this.hseq;
  }
}
